import { Link } from 'react-router-dom';
import './Breadcrumb.css';

function Breadcrumb({ to, label }) {
  return (
    <div className="breadcrumb">
      <Link to={to}>← {label}</Link>
    </div>
  );
}

export default Breadcrumb;
